import React from 'react';
import { Select, Space } from 'antd';
import { usePreference } from '../context/PreferenceContext';
import { GlobalOutlined } from '@ant-design/icons';

const { Option } = Select;

const PreferenceSwitcher = ({ style, mode = 'light' }) => {
    const {
        languages,
        currencies,
        language,
        currency,
        changeLanguage,
        changeCurrency,
        t
    } = usePreference();

    const isDark = mode === 'dark';

    const commonSelectClassName = `normal-select ${isDark ? 'dark' : ''}`;

    const showLanguage = languages && languages.length > 1;
    const showCurrency = currencies && currencies.length > 1;

    if (!showLanguage && !showCurrency) {
        return null;
    }

    return (
        <Space size={8} className="preference-switcher">
            {showLanguage && (
                <Select
                    value={language?.code}
                    onChange={changeLanguage}
                    className={`${commonSelectClassName} pcu-min-w-120`}
                    suffixIcon={<GlobalOutlined className="pcu-color-orange" />}
                >
                    {languages.map(lang => (
                        <Option key={lang.code} value={lang.code}>
                            {t('lang_' + lang.code, lang.name)}
                        </Option>
                    ))}
                </Select>
            )}

            {showCurrency && (
                <Select
                    value={currency?.code}
                    onChange={changeCurrency}
                    className={`${commonSelectClassName} pcu-min-w-80`}
                    optionLabelProp="label"
                >
                    {currencies.map(curr => (
                        <Option key={curr.code} value={curr.code} label={curr.symbol + " " + curr.code}>
                            <Space size={4}>
                                <span className="pcu-color-orange pcu-font-bold">{curr.symbol}</span>
                                <span className="pcu-color-body">{curr.code}</span>
                            </Space>
                        </Option>
                    ))}
                </Select>
            )}

            <style jsx="true">{`
                .preference-switcher :global(.ant-select-selector) {
                    border-radius: 8px !important;
                    background-color: var(--color-bg-card) !important;
                    border: 1px solid var(--color-border-primary) !important;
                    transition: all 0.3s ease !important;
                }
                .preference-switcher :global(.ant-select:hover .ant-select-selector) {
                    border-color: var(--nearzon-orange) !important;
                    box-shadow: 0 0 0 2px rgba(255, 129, 16, 0.1) !important;
                }
                .preference-switcher :global(.ant-select-selection-item) {
                    color: var(--color-text-title) !important;
                    font-weight: 500 !important;
                }
                .preference-switcher :global(.ant-select-arrow) {
                    color: var(--color-text-muted) !important;
                }
            `}</style>
        </Space>
    );
};

export default PreferenceSwitcher;
